import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66626 9.2501C4.66626 9.2501 5.08293 8.83344 6.33293 8.83344C7.58293 8.83344 8.41626 9.66677 9.66626 9.66677C10.9163 9.66677 11.3329 9.2501 11.3329 9.2501V4.2501C11.3329 4.2501 10.9163 4.66677 9.66626 4.66677C8.41626 4.66677 7.58293 3.83344 6.33293 3.83344C5.08293 3.83344 4.66626 4.2501 4.66626 4.2501V9.2501Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66626 12.1667V9.25",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var FlagFillSmall = function FlagFillSmall(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#573AE6' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 16 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8",
    fill: color
  }), _ref2, _ref3);
};

export default FlagFillSmall;